// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"355":"431e249b","488":"adee5ca0"}[chunkId] + ".chunk.js");